var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("pui-lightbox", {
    ref: "globalWaitingModalRef",
    staticClass: "modal",
    attrs: {
      "fit-content": true,
      fullscreen: false,
      "show-lightbox-close-icon": false,
    },
    scopedSlots: _vm._u([
      {
        key: "lightbox-trigger",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
      {
        key: "default",
        fn: function () {
          return [
            _c("pui-loader-spinner", {
              attrs: {
                title: _vm.waitingModalTitle,
                message: _vm.waitingModalContent,
                global: true,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }